export default __webpack_public_path__ + "static/media/art-pro-brw-banner-2.f4031460.jpg";